// How long the short passes last, in whole days, from the environment (TEAMBRIDGE_SOCIAL_PASS_DAYS,
// TEAMBRIDGE_EVENT_PASS_DAYS; defaults = today's 24 hours and 3 days). Checkout writes the days into
// the Stripe session and fulfillment grants them, so every page, the checkout and the access agree.
// Shared by the server (lib/pricing-catalog.js) and the client copy (src/util/*).
export const PASS_DAYS_ENV = Object.freeze({
  SOCIAL_PASS: 'TEAMBRIDGE_SOCIAL_PASS_DAYS',
  EVENT_PASS: 'TEAMBRIDGE_EVENT_PASS_DAYS'
});
export const PASS_DAYS_DEFAULT = Object.freeze({
  SOCIAL_PASS: 1,
  EVENT_PASS: 3
});
// The windows a pass can be sold with; any other setting falls back to the default. Fulfillment
// accepts every one of them, so a session sold just before the setting changes still completes.
export const PASS_DAYS_CHOICES = Object.freeze({
  SOCIAL_PASS: Object.freeze([1, 2, 7]),
  EVENT_PASS: Object.freeze([3, 4, 7, 14, 30])
});
export const validPassDays = (offerId, days) => Object.prototype.hasOwnProperty.call(PASS_DAYS_CHOICES, offerId) && PASS_DAYS_CHOICES[offerId].includes(days);
export function passDays(offerId, env = {}) {
  const raw = String(env[PASS_DAYS_ENV[offerId]] ?? '').trim();
  const days = /^\d+$/.test(raw) ? Number(raw) : NaN;
  return validPassDays(offerId, days) ? days : PASS_DAYS_DEFAULT[offerId];
}

// "24 hours", "3 days", "7 days", "12 months": how long a pass lasts, in copy.
export function passWindow(days) {
  if (days === 365) return '12 months';
  if (days === 1) return '24 hours';
  return `${days} days`;
}

// The same with the hours spelled out where they help: "3 days (72 hours)"; a week stays "7 days".
export function passWindowLong(days) {
  return days > 1 && days <= 3 ? `${days} days (${days * 24} hours)` : passWindow(days);
}